import Dashboard from '../pages/Dashboard';
import WaiterDashboard from '../pages/WaiterDashboard';
import ChefDashboard from '../pages/ChefDashboard';
import ManagerDashboard from '../pages/ManagerDashboard';

export type UserRole = 'admin' | 'server' | 'chef' | 'manager';

export const roleTitles: Record<UserRole, string> = {
  admin: 'Admin Dashboard',
  server: 'Server Dashboard',
  chef: 'Kitchen Dashboard',
  manager: 'Manager Dashboard'
};

export const roleSubtitles: Record<UserRole, string> = {
  admin: 'System Overview and Control',
  server: 'Service Management Panel',
  chef: 'Orders in Preparation',
  manager: 'Reports and Team Activity'
};

export const dashboards = {
  admin: Dashboard,
  server: WaiterDashboard,
  chef: ChefDashboard,
  manager: ManagerDashboard
} as const;

export const getDashboardComponent = (role: string) => {
  if (!role || !dashboards[role as UserRole]) {
    console.warn(`No dashboard defined for role: ${role}`);
    return null;
  }
  return dashboards[role as UserRole];
}; 